import React from "react";

import { ButtonClickCard } from "components/ButtonClickCard";

import { formatDateTime } from "utils/dateTime";

export const handleCloseDrawer = (
  setOpenDrawer: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  setOpenDrawer(false);
};

interface ISystemNotificationrBody {
  id: number;
  userId: number;
  message: string;
  url: string;
  createIn: Date;
  read: boolean;
}

export const handleList = (
  listNotifications: Array<ISystemNotificationrBody>,
  setNotificationId: React.Dispatch<React.SetStateAction<number>>,
) => {
  return listNotifications.map((item) => {
    return (
      <ButtonClickCard
        key={item.id}
        title={formatDateTime.getFullDate(item.createIn)}
        subTitle={item.message}
        tooltipMessagem="Ler mensagem"
        onClick={() => setNotificationId(item.id)}
        typeButton="radio"
        typeIcon="file"
      />
    );
  });
};
